import React, { useState, useEffect } from 'react';
import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import { IsEmpty } from '../../../common/checks';

const DatePickerV2 = ({ callback, dateVal }) => {
  const [value, setValue] = useState(['', '']);

  useEffect(() => {
    setValue(!IsEmpty(dateVal) ? dateVal : value);
  }, [dateVal]);

  const onChange = (dates) => {
    setValue(dates);

    // set callback
    callback(dates);
  };

  return (
    <div>
      <DateRangePicker
        onChange={(e) => onChange(e)}
        value={value}
        format="y-MM-dd"
        dayPlaceholder="dd"
        monthPlaceholder="mm"
        yearPlaceholder="yyyy"
      />
    </div>
  );
};

export default DatePickerV2;
